import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { db, StoredItem } from '../db/db.service';

@Injectable({
  providedIn: 'root'
})
export class DataStorageService {

  constructor() { }

  saveData(data: any[]): Observable<number> {
    return from(db.items.put({ holData: data, isReady: true }, 1));
  }

  getAllData(): Observable<StoredItem[]> {
    return from(db.items.toArray());
  }

  clearData(): Observable<void> {
    return from(db.items.clear());
  }
}